import { StyleSheet } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';

const dialogStyles = StyleSheet.create({
	dropdown: {
		padding: Dimens.padding8,
	},
	modalView: {
		flex: Dimens.flex1,
	},
	centeredView: {
		flex: Dimens.flex1,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: Colors.black77,
	},
	modalCard: {
		backgroundColor: Colors.white,
		borderRadius: Dimens.borderRadius7,
		width: '90%',
		maxWidth: Dimens.size400,
		padding: Dimens.padding20,
		overflow: 'hidden',
	},
	modalTitle: {
		fontSize: Dimens.fontSize20,
		fontFamily: Fonts.ptSerif,
		textAlign: 'center',
		marginBottom: Dimens.padding20,
	},
	modalDescription: {
		color: Colors.gray550,
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize14,
		lineHeight: Dimens.lineHeight24,
		marginBottom: Dimens.padding30,
		textAlign: 'center',
	},
});

export default dialogStyles;
